module.exports = __webpack_public_path__ + "static/media/teygja_brjostvodvar_a.c3a51d72.png";